import { ActionTypes } from '../../constants/ActionTypes';

// convertStatus
export const onGetConvertStatus = (letterCode: string | undefined) => {
  return {
    payload: letterCode,
    type: ActionTypes.GET_CONVERTSTATUS,
  };
};

export const fetchConvertStatusSuccess = (convertStatus: boolean) => {
  return {
    type: ActionTypes.FETCH_CONVERTSTATUS_SUCCESS,
    payload: convertStatus,
  };
};
